import { createContext, useContext } from "react";

const ChartIdContext = createContext(null);

export const ChartIdProvider = ChartIdContext.Provider;

export function useChartId() {
  return useContext(ChartIdContext);
}
